import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto sm:px-3 md:px-44 lg:px-24 mt-10" }
const _hoisted_2 = { class: "grid grid-rows-3 grid-flow-col grid-cols-3 gap-4" }
const _hoisted_3 = { class: "row-span-3" }
const _hoisted_4 = { class: "flex flex-col p-4" }
const _hoisted_5 = { class: "mb-2 border-b-2 p-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { className: "block sm:hidden xl:block pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { className: "font-bold text-gray-300 text-sm" }, "Info"),
  /*#__PURE__*/_createElementVNode("div", { className: "text-gray-500 text-xs" }, " Joined 09:12 am November 08,2022 ")
], -1)
const _hoisted_7 = {
  class: "btn btn-medium btn-secondary",
  "on:click": "{signout}"
}
const _hoisted_8 = { class: "col-span-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicHeader = _resolveComponent("PublicHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Disclaimer = _resolveComponent("Disclaimer")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PublicHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_component_router_link, { to: "/my-account/profile" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.titles_profile), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_6,
          _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.actions_signout), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component, route }) => [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                    key: route.path
                  }))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_Disclaimer)
    ]),
    _createVNode(_component_Footer)
  ], 64))
}